const PRIVACIDADE_URL_DEFAULT = "/politica-de-privacidade/";

const getPrivacidadeUrl = (allinfoText) => {
  return allinfoText?.Privacidade?.Url &&
    allinfoText.Privacidade.Url !== ""
    ? allinfoText.Privacidade.Url
    : PRIVACIDADE_URL_DEFAULT;
};

export { PRIVACIDADE_URL_DEFAULT, getPrivacidadeUrl };
